import { gql, useMutation } from '@apollo/client';
import { useAuth } from '../auth/useAuth';
import { useLogger } from '@amzn/xb-hooks';
import { WITHDRAW_LEARNING_ACTIVITY_ERROR } from '../../common/rumMetrics';

export const WITHDRAW_LEARNING_ACTIVITY = gql`
    mutation withdrawLearningActivity($userId: ID!, $learningActivityId: ID!) {
        withdrawLearningActivity(userId: $userId, learningActivityId: $learningActivityId) {
            id
            registrationStatus
        }
    }
`;

export const useWithdrawLearningActivity = (learningActivityId: string) => {
    const { log, count } = useLogger();
    const { user } = useAuth();
    return useMutation(WITHDRAW_LEARNING_ACTIVITY, {
        variables: { userId: user.id, learningActivityId: learningActivityId },
        onError: (error) => {
            log.error('Error withdrawing learning activity', error);
            count(WITHDRAW_LEARNING_ACTIVITY_ERROR);
        },
    });
};
